import UIViewportDialogService from './UIViewportDialogService';

export default UIViewportDialogService;
